import moment from "moment";
import weekOfMonth from "./weekOfMonth";
import formatOrdinalNumber from "./formatNumberOrdinal";
import { pnl_type } from "../Constants/constants";

/**
 * [getPnlInfo Formats P&L table header]
 * @param  {Array} userSegment
 *
 * @return {Element}
 */
export default function getPnlInfo(elementData) {
  const pnlType = pnl_type[elementData.pnl_type]
    ? pnl_type[elementData.pnl_type]
    : "Shared P&L";
  let dateText = "";
  if (elementData.pnl_type === 1) {
    // Day P&L
    dateText = elementData.pnl_data?.summary?.from_date
      ? moment
          .unix(elementData.pnl_data?.summary?.from_date)
          .format("DD MMMM YYYY, dddd")
      : "";
  } else if (elementData.pnl_type === 2) {
    // Weekly P&L
    const week_from_date = elementData.pnl_data?.summary?.from_date;
    if (week_from_date) {
      const inputWeek = weekOfMonth(week_from_date);
      if (inputWeek) {
        const ordinalWeek = formatOrdinalNumber(inputWeek);
        if (ordinalWeek) {
          const formattedMonthYear = moment
            .unix(week_from_date)
            .format("MMM YYYY");
          dateText = `${ordinalWeek} week of ${formattedMonthYear}`;
        }
      }
    }
  } else if (elementData.pnl_type === 3) {
    // Monthly P&L
    dateText = elementData.pnl_data?.summary?.from_date
      ? `${moment
          .unix(elementData.pnl_data?.summary?.from_date)
          .format("MMM YYYY")}`
      : "";
  } else if (elementData.pnl_type === 4) {
    // Custom P&L
    const from_data = elementData.pnl_data?.summary?.from_date;
    const to_data = elementData.pnl_data?.summary?.to_date;
    if (from_data && to_data) {
      const formatted_from_date = moment.unix(from_data).format("DD MMM YYYY");
      const formatted_end_date = moment.unix(to_data).format("DD MMM YYYY");
      dateText = `${formatted_from_date} - ${formatted_end_date}`;
    }
  }
  return `${pnlType} ${dateText ? ` : ${dateText}` : ""}`;
}
